import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { MiBuildPageHeader, MiIcon } from "@miplatform/components";
import * as Icons from "@mdi/js";
import { Box, Typography, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import { usePermissions } from "../../hooks";
import { adminChildNavItem } from "../../routes/admin/adminNavItems";
import { generateRoutesByPermissions } from "../../utils/filterRoutes/filterRoutes";

export function AdminSettings({ page, title }) {
  const theme = useTheme();

  const { classes } = useStyles();
  const { permissions } = usePermissions();

  const navData = generateRoutesByPermissions(
    adminChildNavItem[page],
    permissions
  );

  return (
    <Box className={classes.contentContainer}>
      <MiBuildPageHeader title={title} color={theme.palette.primary.main} />
      <Box className={classes.container}>
        {navData?.map((item) => (
          <Link
            to={item.path}
            key={`card${item.path}`}
            style={{ textDecoration: "none" }}
            data-testid={item.testId}
          >
            <Card className={classes.card} sx={{ boxShadow: 2 }}>
              <Box className={classes.iconContainer}>
                {item?.icon && (
                  <MiIcon
                    path={Icons[item?.icon]}
                    size={2}
                    color={theme.palette.primary.main}
                  />
                )}
              </Box>

              <Box className={classes.labelContainer}>
                <Typography className={classes.label}>{item?.name}</Typography>
                <Typography className={classes.subLabel}>
                  {item?.description}
                </Typography>
              </Box>
            </Card>
          </Link>
        ))}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    height: "inherit",
    overflowY: "auto",
    margin: 16,
    boxShadow: `-1px -1px ${theme.palette.grey[300]}`,
    padding: 20,
    backgroundColor: theme.palette.common.white,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 20,
    borderRadius: 10,
    alignItems: "flex-start",
    alignContent: "flex-start",
    flex: 1,
  },
  card: {
    cursor: "pointer",
    width: 200,
    height: 200,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
  },
  iconContainer: {
    backgroundColor: theme.palette.common.white,
  },
  label: {
    fontSize: theme.fontSize.medium,
    fontWeight: theme.fontWeight.bold,
  },
  labelContainer: {
    marginTop: 10,
    textAlign: "center",
  },
  subLabel: {
    fontSize: theme.fontSize.small,
    color: theme.palette.grey.medium,
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "inherit",
  },
}));
